import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as cafeActions from '../../../redux/cafes/actions';
import Pagination2 from '../../../components/Pagination2';
import AddUserModal from './modals/addUser';
import DeleteUserModal from './modals/deleteUserModal';
import Spin from '../../../components/loading';
import ShowForPermission from '../../../components/ShowForPermission';
import ENUMS from '../../../enums';
class UsersTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      itemsPerPage: 10,
      editMode: false,
      addUserOpen: false,
      deleteUserOpen: false,
      selectedUserId: -1,
      selectedFullName: ''
    };
  }

  componentDidMount() {
    this.props.fetchAllCafeUsers(this.props.location.cafeId);
  }

  handlePageChange = number => this.setState({ currentPage: number.currentPage });

  closeAddUserModal = cafeId => {
    this.props.fetchAllCafeUsers(cafeId || this.props.location.cafeId).then(() => {
      this.setState({ addUserOpen: false }, () => {});
    });
  };

  displayAddUserModal = id => {
    if (id) {
      let { usersList = [] } = this.props;
      let selectedUser = usersList.filter(user => user.id == id)[0];
      this.setState({
        addUserOpen: true,
        selectedUserId: selectedUser.id,
        selectedFullName: selectedUser.fullName,
        editMode: true
      });
    } else {
      this.setState({ addUserOpen: true, editMode: false });
    }
  };

  closeDeleteUserModal = cafeId => {
    this.props.fetchAllCafeUsers(cafeId || this.props.location.cafeId).then(() => {
      this.setState({ deleteUserOpen: false });
    });
  };

  displayDeleteUserModal = id => {
    let { usersList = [] } = this.props;
    let selectedUser = usersList.filter(user => user.id == id)[0];
    this.setState({
      deleteUserOpen: true,
      selectedUserId: selectedUser.id,
      selectedFullName: selectedUser.fullName
    });
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;

    console.log('pagination data: ', data);

    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.getCafes(query);
    });
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      console.log('pageNumber is: ', pageNumber);
      console.log('pageSize is: ', pageSize);
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  render() {
    let { usersList = [], loading, failed, error, message } = this.props,
      { totalRecords } = this.props.cafeUsers,
      { currentPage, itemsPerPage } = this.state;
    return (
      <>
        <section className="p-1 col-12">
          <div className="col-12 d-flex align-items-center justify-content-between">
            <h3 className="text-right text-muted py-4">
              {locales('titles.cafeUsers')}{' '}
              {(this.props.location.cafeName || '').replace(locales('titles.cafe'), '')}
            </h3>
            <ShowForPermission permission={ENUMS.PERMISSIONS.values.ADD_NEW_CAFE_USER}>
              <div className="d-flex justify-content-end p-0">
                <button type="button" onClick={() => this.displayAddUserModal()} className="btn btn-primary">
                  <i className="fa fa-plus" />
                  {locales('titles.assignOrEditUser')}
                </button>
                <button
                  onClick={() => this.props.history.push('/cafes')}
                  className="btn btn-default w-5 mx-1"
                >
                  <i className="fa fa-reply" />
                  {locales('labels.cancel')}
                </button>
              </div>
            </ShowForPermission>
          </div>
          {/* <div className='col-12 d-flex justify-content-center align-items-center h-100'> */}
          <Spin spinning={loading}>
            <article>
              <main className="panel panel-default">
                {error ? (
                  <div className="alert alert-danger">{locales('messages.server.error')}</div>
                ) : (
                  <>
                    {failed && <div className="alert alert-danger">{message}</div>}
                    <div className="panel-heading">
                      <i className="fas fa-list-alt px-1" />
                      {locales('titles.usersList')}
                    </div>
                    <div className="panel-body">
                      <table className="table table-hover table-light table-striped">
                        <thead className="thead-dark">
                          <tr>
                            <th className="text-center"></th>
                            <th className="text-center">{locales('tables.fullName')}</th>
                            <th className="text-center">{locales('messages.username')}</th>
                            <th className="text-center">{locales('fields.mobileNumber')}</th>
                            <th className="text-center">{locales('tables.roles')}</th>
                            <th className="text-center">{locales('tables.date')}</th>
                            <th className="text-center"></th>
                            <th className="text-center"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {usersList.length ? (
                            usersList.map(user => (
                              <tr key={user.id}>
                                <td className="text-center">{user.avatarUrl}</td>
                                <td className="text-center">{user.fullName}</td>
                                <td className="text-center">{user.userName || '---'}</td>
                                <td className="text-center">{user.mobileNumber}</td>
                                <td className="text-center text-center d-flex justify-content-center align-items-center flex-wrap">
                                  {user.roles.map((role, roleIndex) => (
                                    <span className="d-flex flex-wrap" key={role.id}>
                                      {role.title}
                                      {roleIndex < user.roles.length - 1 ? '،' : ''}
                                    </span>
                                  ))}
                                </td>
                                <td className="text-center">{user.createdAt}</td>
                                <ShowForPermission
                                  permission={
                                    ENUMS.PERMISSIONS.values.EDIT_CAFE_USER &&
                                    ENUMS.PERMISSIONS.values.VIEW_CAFE_USER_DETAILS
                                  }
                                >
                                  <td
                                    onClick={() => this.displayAddUserModal(user.id)}
                                    title={locales('titles.editUser')}
                                    className="text-center"
                                  >
                                    <i className="fa text-info pointer fa-pencil" />
                                  </td>
                                </ShowForPermission>
                                <ShowForPermission permission={ENUMS.PERMISSIONS.values.DELETE_CAFE_USER}>
                                  <td title={locales('titles.deleteUser')} className="text-center">
                                    <i
                                      onClick={() => this.displayDeleteUserModal(user.id)}
                                      className="fal fa-trash pointer text-danger"
                                    />
                                  </td>
                                </ShowForPermission>
                              </tr>
                            ))
                          ) : (
                            <tr className="col-12 text-center">
                              <td className="alert alert-info" colSpan={12}>
                                {locales('alerts.noRecord')}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      <footer className="col-12 d-flex justify-content-center py-2">
                        <div className="pagination-container">
                          <Pagination2
                            totalRecords={totalRecords || 0}
                            pageLimit={itemsPerPage}
                            pageNeighbours={2}
                            onPageChanged={this.handlePageChange}
                            currentPage={currentPage}
                          />
                        </div>
                      </footer>
                      {this.state.addUserOpen && (
                        <AddUserModal
                          cafeId={this.props.location.cafeId}
                          editMode={this.state.editMode}
                          isOpen={this.state.addUserOpen}
                          userId={this.state.selectedUserId}
                          cafeName={this.props.location.cafeName}
                          fullName={this.state.selectedFullName}
                          closeModal={this.closeAddUserModal}
                        />
                      )}
                      {this.state.deleteUserOpen && (
                        <DeleteUserModal
                          cafeId={this.props.location.cafeId}
                          isOpen={this.state.deleteUserOpen}
                          fullName={this.state.selectedFullName}
                          userId={this.state.selectedUserId}
                          cafeName={this.props.location.cafeName}
                          closeModal={this.closeDeleteUserModal}
                        />
                      )}
                    </div>
                  </>
                )}
              </main>
            </article>
          </Spin>
        </section>
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    cafeUsers: state.cafesReducer.cafeUsersList,
    usersList: state.cafesReducer.cafeUsersList.users,
    failed: state.cafesReducer.getAllCafeUsersFailed,
    error: state.cafesReducer.getAllCafeUsersError,
    message: state.cafesReducer.getAllCafeUsersMessage,
    loading: state.cafesReducer.getAllCafeUsersLoading
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchAllCafeUsers: id => dispatch(cafeActions.fetchAllCafeUsers(id))
  };
};
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UsersTable)
);
